
Moving pictures and I named a star together. His name is Bruce.

> Btw, actually do have a star named after me. It's name is Daddy Warbucks. My aunt purchased its naming rights back in 2006 after I played the role in Annie Jr.

### Reflections

Story. Tale. Soundtrack. Sound effect. Pure, raw, unfiltered single serving of emotion. Swallow the pill with its trailer nutrition label and see where it lands you.

I recently had a friend tell me that there's a Meyers Briggs profile match in every movie/tv show role. For example, theirs was Ryan from The Office. Ever since, I've been trying to simile characters, friends and people. For example, if Christine from the movie Lady Bird was an instrument, she'd be a clarinet.

<br />
<iframe src="https://open.spotify.com/embed/track/0Fz6GMHslzS7bWbZILex1R" width="300" height="380" frameborder="0" allowtransparency="true"></iframe>
<br />

I've always thought of the clairnet as one of the hardest instruments to master. Play maybe sure, but master? Nope.

> [I've been playing the clarinet for 5 years now and its pretty difficult because you need to find a good reed, you need A LOT of air, you need to be able to articulate notes, change dynamics, and much much more. It's a complicated instrument. It's definitely not easy.](https://www.thetoptens.com/hardest-instruments-play/clarinet-459267.asp)

It's not just the difficulty though, it's the tone. The soundtrack rings between my ears and the fade to black credit scene swirls around in my eyes.

### The Movie

Christine "Lady Bird" McPherson and her lovely red hair trekked me back through my primary and secondary school years this afternoon.

Each scene a flash of emotive display, she shared in my Catholocisim, drama/theater experience, "I respect you too much", attempt at the cool kid friends and much, much more.

The missing female _Boyhood_ standing against Richard Linklater's episodic film by similarly spoonfeeding life events to the audience.

Like I just watched my older sister's youth, tbh. Maybe if my family lived in northern California circa early 2000s...

Lightly touching on topics such as female masturbation and first sexual experiences, I just caught a glimpse into the life of my future daughter, niece, grandaughter, etc in a way that I might never be able to glean from asking a woman directly.

### Review

Well done. Bravo. 10/10.
